import { AxiosService } from '@services'
import { Endpoints } from '@network/endpoints'
import { IPayload } from '@network/models/global.model'
import {
  IChangePasswordParams,
  IForgotPasswordParams,
  IResetPasswordParams,
} from '@network/models/password.model'

export class PasswordApi {
  constructor(private axios: AxiosService) {}

  forgotPassword = async (params: IForgotPasswordParams) => {
    const response = await this.axios.post<{}>(Endpoints.forgotPassword, params)
    return response
  }

  resetPassword = async (params: IResetPasswordParams) => {
    const response = await this.axios.post<{}>(Endpoints.resetPassword, params)
    return response
  }

  changePassword = async (params: IChangePasswordParams) => {
    const response = await this.axios.post<IPayload<{}>>(
      Endpoints.changePassword,
      params,
    )
    return response
  }
}
